<template>
  <app-page-hero-banner
    cover="https://res.cloudinary.com/dfdgwwkpd/image/upload/v1712830462/brand/enterprise/2ce22d8170e0378a38bdaaef42bb7d1d_eo68ed.jpg"
    :title="$t('enterprise.page.title')"
  >
    <template #subtitle>
      <ul class="grid gap-4 text-lg md:text-xl">
        <li
          v-for="item in list"
          :key="item.label"
          class="flex -items-center gap-3"
        >
          <app-icon :icon="item.icon" />
          <span v-html="item.label" />
        </li>
      </ul>
    </template>

    <template #append>
      <growth-contact-button
        origin="enterprise"
        origin_page_action="hero_cta"
        size="xl"
      >
        Parler à un conseiller
      </growth-contact-button>
    </template>
  </app-page-hero-banner>
</template>

<script lang="ts" setup>
import type { I18nMessage } from "@pollen/core/model/i18n.model";

const list: { label: I18nMessage; icon: string }[] = [
  {
    icon: "ph:fire",
    label:
      "Des <strong>professionnels reconnus</strong> qui ont marqué leur industrie sont <strong>vos formateurs</strong>",
  },
  {
    icon: "ph:cursor-click",
    label:
      "Une <strong>méthodologie unique</strong> pour des formations actionnables et engageantes",
  },
  {
    icon: "ph:atom",
    label:
      "Un savoir-faire reconnu de <strong>personnalisation à vos enjeux</strong>",
  },
];
</script>
